import { useRouter } from 'next/router';
import React from 'react';

import { RegisterComponent } from '@app/components/auth/RegisterComponent';
import { withLayout } from '@components/withLayout';

export const RegisterPage: React.FC = () => {
  const router = useRouter();

  const onRegister = (email: any) => {
    try {
      sessionStorage.setItem('email', typeof email === 'string' ? email : (email as any).value);
    } finally {
      router.push('/auth/otp?action=register');
    }
  };

  return <RegisterComponent onRegister={onRegister} />;
};

export default withLayout(RegisterPage, 'auth');
